import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (desktop): one hotel banner
 * under the site nav, above the article. The hotel card is a static
 * placeholder; it is not a template field.
 */
@Component({
  selector: 'app-pmax-display-desktop-02',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './display-desktop-02.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-desktop-02.component.scss'
})
export class PmaxDisplayDesktop02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton nav bars under the site name. */
  readonly navItems = [0, 1, 2, 3];

  /** Skeleton text lines above the article image, as % widths. */
  readonly articleLines = [100, 100, 100, 100, 75];

  readonly hotel = { image: HOTELS + 'girandella.jpg', title: 'Girandella Family', subtitle: 'Najbolja cijena' };

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
